import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PedidosService} from "../../services/pedidos.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {GridPedidosComponent} from "../grid-pedidos/grid-pedidos.component";
import {TipoDePagamentoEnum} from "../objetos/TipoDePagamentoEnum";
import {Pagamento} from "../objetos/Pagamento";
import {NgForm} from "@angular/forms";
import {ComandosImprimirComanda} from "../ComandosImprimirComanda";
import {ImpressaoService} from "../../services/impressao.service";
import {PedidoLocalService} from "../../services/pedido-local.service";
import {PontuacaoRegistrada} from "../../../../server/domain/PontuacaoRegistrada";
import {IUITipoDePontuacaoFactory} from "../../objetos/IUITipoDePontuacaoFactory";
import {FormatadorPontos} from "../objetos/FormatadorPontos";
import {GridPagamentoComponent} from "../grid-pagamento/grid-pagamento.component";
import {MonitoradorPedidos} from "../../fidelidade/MonitoradorPedidos";
import {ComandaService} from "../../services/comanda.service";
import {EmpresaService} from "../../services/empresa.service";
import { DeviceDetectorService } from 'ngx-device-detector';
import {AutorizacaoService} from "../../services/autorizacao.service";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";

import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {
  ModalEditarItempedidoMesaComponent
} from "../../fidelidade/modal-editar-mesa/modal-editar-itempedido-mesa.component";
import {obtenhaRotaNovoPedidoLocal} from "../pdv-local-config";
import {ModalVincularGarcomComponent} from "../../fidelidade/modal-vincular-garcom/modal-vincular-garcom.component";


@Component({
  selector: 'app-tela-fechar-comanda',
  templateUrl: './tela-fechar-comanda.component.html',
  styleUrls: ['./tela-fechar-comanda.component.scss']
})
export class TelaFecharComandaComponent extends ComandosImprimirComanda implements OnInit, OnDestroy {
  @ViewChild('gridPedidos', { static: false}) gridPedidos: GridPedidosComponent;
  @ViewChild('gridPagamentos') gridPagamentos: GridPagamentoComponent;
  @ViewChild('pagamentoCard') pagamentoCard: ElementRef<HTMLElement>;
  @ViewChild('pixClienteNomeInput') pixClienteNomeInput: ElementRef<HTMLInputElement>;
  desconto = 0;
  tipoDesconto: 'valor' | 'porcentagem' = 'valor';
  valorDescontoInput = 0;

  comanda: any;
  carregou: boolean;
  carregando = false;
  tipoDePagamento = TipoDePagamentoEnum;
  formasDePagamento = [];
  @ViewChild('frm', { static: false})  frm: NgForm;
  troco: number;
  fechando: boolean;
  erro: string;
  erroAnimando = false;
  fecharSomenteMeucardapio = false;
  imprimindo: boolean;
  formasPagamentoMesa: any = []
  carregandoFormasPagamentos = false;
  private versaoCarregamentoFormasPagamento = 0;
  erroFechaParceiro: boolean;
  fecharSemPrechamento = false; //quando opcional fazer fechamento.
  exibirPrefechamento = false;
  sucessoFechamento = false;
  botaoPulsando = false;
  isMobile: boolean;
  operador: any = {}
  exibirPixOnlineTuna = false;
  gerandoPixOnlineTuna = false;
  dadosClientePixOnline: any = {};
  pagamentoPixOnline: any;
  mensagemPixCopiado = '';
  erroPixOnlineTuna: string;
  formaPixOnlineTuna: any;
  cancelandoPixOnlineTuna = false;
  confirmandoCancelamentoPixOnlineTuna = false;
  tentouGerarPixOnlineTuna = false;
  pixOnlineTunaTempoRestante = '';
  pixOnlineTunaExpirado = false;
  private pixOnlineTunaTimer: any;
  private pixOnlineTunaPolling: any;
  sincronizandoPixOnlineTuna = false;
  constructor(protected constantsService: ConstantsService, protected pedidosService: PedidosService,
              private router: Router, private activatedRoute: ActivatedRoute, protected impressao: ImpressaoService,
              private comandaService: ComandaService, private empresaService: EmpresaService,
              private pedidoLocalService: PedidoLocalService,     public monitoradorPedidos: MonitoradorPedidos,
              private deviceService: DeviceDetectorService, private autorizacaoService: AutorizacaoService,
              private dialogService: DialogService) {
    super(pedidosService, constantsService, impressao);
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.operador = this.autorizacaoService.getUser() || {};

    this.activatedRoute.queryParams.subscribe( (queryParams) => {
      this.formasDePagamento = [];

      const idComanda = this.activatedRoute.snapshot.params.id;

      this.pedidosService.obtenhaComandaComoPedido(idComanda).then( (comanda: any) => {
        this.setComanda(comanda);
      }).catch( (erro) => {
        this.carregou = true;
      });
    });
  }

  ngOnDestroy(): void {
    this.pareContadorPixOnline();
    this.parePollingPixOnline();
  }

  private async setComanda(comanda: any) {
    const valorServidor = Number(comanda?.valorServidorComanda != null ? comanda.valorServidorComanda : comanda?.valor || 0);

    this.comanda = Object.assign({}, comanda, {
      valorServidorComanda: valorServidor
    });
    this.exibirPrefechamento = this.comanda.preFechamentoDisponivel ? true : false;
    this.desconto = Number(this.comanda.desconto || 0);
    this.valorDescontoInput = this.desconto;

    if(this.desconto){
      this.comanda.valor = Number((valorServidor + this.desconto).toFixed(2));
    }

    setTimeout( () => {
      if( !this.gridPedidos ) { return; }

      this.gridPedidos.atualizeGridPedidos(this.comanda.pedidos, 'mesa');
    }, 0);


    if(! this.comanda.pagamento)
      this.comanda.pagamento = new Pagamento();

    await this.setFormasPagamentoMesa();

    this.formasDePagamento.forEach(formaDePagamento => {
      let formaDePagamentoComanda = this.comanda.pagamento.formaDePagamento;

      if( this.comanda.cashback && formaDePagamento.nome.toLowerCase() === 'cashback')
        this.comanda.cashback.formaDePagamento = formaDePagamento;

      if( formaDePagamentoComanda && formaDePagamentoComanda.id === formaDePagamento.id )
        this.comanda.pagamento.formaDePagamento = formaDePagamento;

    });

    this.carregou = true;
    this.calculePontosAhReceber();
    this.formaPixOnlineTuna = this.obtenhaFormaPixOnlineTuna();
    const pagamentoPixPendente = this.obtenhaPixOnlineTunaPendente();
    this.pagamentoPixOnline = pagamentoPixPendente || null;
    if(pagamentoPixPendente) {
      this.exibirPixOnlineTuna = true;
      delete this.erroPixOnlineTuna;
    } else {
      this.pagamentoPixOnline = null;
      this.pareContadorPixOnline();
      if(this.exibirPixOnlineTuna)
        this.exibirPixOnlineTuna = false;
    }
    this.preenchaDadosClientePixOnline();
    this.inicieContadorPixOnline();
    this.atualizePollingPixOnline();
    this.sincronizeTotalGridPagamentos();

  }

  voltar() {
    this.router.navigateByUrl('/admin/pedidos-mesas', {}).then( () => {});
  }

  calculeTroco() {
    setTimeout( () => {
      let valor = this.totalDaComanda();

      if(this.comanda.pagamento && this.comanda.pagamento.trocoPara) {
        this.troco = this.comanda.pagamento.trocoPara - valor;

        if(this.troco < 0) this.troco = 0;
      }
      else
        this.troco = 0;
    }, 0);
  }

  exibeBotaoSelecionarPagamentoMobile(): boolean {
    return !!(this.comanda && (this.comanda.aberta || this.comanda.emFechamento) &&
      this.comanda.valor && !this.exibirPrefechamento && !this.pixOnlineTunaPendente());
  }

  roleParaPagamento() {
    if(!this.pagamentoCard || !this.pagamentoCard.nativeElement) return;

    const elemento = this.pagamentoCard.nativeElement;
    const rect = elemento.getBoundingClientRect();
    const destino = window.pageYOffset + rect.top - ((window.innerHeight - rect.height) / 2);

    window.scrollTo({
      top: Math.max(0, destino),
      behavior: 'smooth'
    });
  }

  enviePreFechamento(){
    const dados: any = {
      id: this.comanda.id,
      desconto: this.desconto
    }

    this.fechando = true;
    this.pedidosService.enviePrefechamentoComanda(dados).then( (resposta) => {
      this.fechando = false;
      this.setComanda( resposta.comanda)
      if(resposta.erroNotificar)
        this.erro = resposta.erroNotificar;

    }).catch((erro) => {
      this.fechando = false;
      this.erro = erro;
    })

    return false;
  }

  cancelarFecharDireto(){
    this.exibirPrefechamento = true;
    this.fecharSemPrechamento = false;

  }

  private setErro(mensagem: string) {
    // Remove a mensagem atual para triggar a animação novamente
    this.erro = '';
    this.erroAnimando = false;

    setTimeout(() => {
      this.erro = mensagem;
      this.erroAnimando = true;

      // Remove a classe de animação após ela terminar
      setTimeout(() => {
        this.erroAnimando = false;
      }, 500);
    }, 10);
  }

  onSubmitFecharComanda($event: any) {
    if(this.pixOnlineTunaPendente()){
      this.setErro('Cancele o Pix gerado antes de fechar a comanda');
      this.pulseBotao();
      return;
    }

    if(this.pixOnlineTunaSelecionadoParaGerar()){
      this.setErro('Gere o Pix antes de fechar a comanda ou selecione outra forma de pagamento');
      this.pulseBotao();
      return;
    }

    if (!this.frm.valid || this.fechando) {
      this.pulseBotao();
      if (!this.frm.valid)
        this.setErro('Por favor, preencha todos os campos obrigatórios');

      return;
    }

    //pre fe-chamento opcional
    if(this.exibirPrefechamento){
      this.exibirPrefechamento = false;
      this.fecharSemPrechamento = true;
      //retornar para escolher formas de pagamentos
      return;
    }

    delete this.erro;
    this.sucessoFechamento = false;

    const dados: any = {
      id: this.comanda.id,
      fecharNoParceiro: this.fecharSomenteMeucardapio ? false : true,
      desconto: this.desconto,
      cobrarTaxaServico:  this.ehParaCobrarTaxa()
    }

    if(this.totalDaComanda() > 0){
      this.erro = this.gridPagamentos.obtenhaErroPagamento();

      if(this.erro != null) {
        this.pulseBotao();
        this.setErro(this.erro);
        return;
      }

      dados.pagamentos = this.gridPagamentos.pagamentos;
    }

    this.fechando = true;

    delete this.erroFechaParceiro;
    this.pedidosService.fecheComanda(dados).then( (resposta) => {
      this.fechando = false;
      this.setComanda(resposta.comanda);
      if(resposta.erroNotificar) {
        this.setErro(resposta.erroNotificar);
        this.pulseBotao();
      } else {
        this.sucessoFechamento = true;
      }
    }).catch((erro) => {
      this.fechando = false;
      this.setErro(erro);
      if(erro.indexOf('fechar') >= 0 || erro.indexOf('foi enviado') >= 0)
        this.erroFechaParceiro = true;
      this.pulseBotao();
    })
  }

  podeEmitirNfceDaComanda(): boolean {
    if(!this.gridPedidos) return false;

    return this.gridPedidos.podeEmitirNfceDaComanda(this.comanda);
  }

  emitirNfceDaComanda(event?: any): void {
    if(!this.gridPedidos) return;

    this.gridPedidos.emitirNfceDaComanda(this.comanda, event);
  }

  private pulseBotao() {
    if (this.botaoPulsando) return;

    this.botaoPulsando = true;
    const botoes = document.querySelectorAll('.btn-fechar-comanda');
    botoes.forEach(botao => {
      botao.classList.add('btn-pulse');
      setTimeout(() => {
        botao.classList.remove('btn-pulse');
        this.botaoPulsando = false;
      }, 300);
    });
  }

  async setFormasPagamentoMesa(){
    const versaoCarregamento = ++this.versaoCarregamentoFormasPagamento;

    if(this.obtenhaPixOnlineTunaPendente()) {
      this.formasPagamentoMesa = [];
      this.carregandoFormasPagamentos = false;
      return;
    }

    if((this.exibirPrefechamento || this.comanda.emFechamento) && !this.fecharSomenteMeucardapio && this.empresaTemEcletica()){
      this.carregandoFormasPagamentos = true;
      try {
        const formasPagamentoMesa = await this.empresaService.listeFormasAtivasMesa();
        if(versaoCarregamento !== this.versaoCarregamentoFormasPagamento) return;
        this.formasPagamentoMesa = formasPagamentoMesa;
      } finally {
        if(versaoCarregamento === this.versaoCarregamentoFormasPagamento)
          this.carregandoFormasPagamentos = false;
      }
    } else {
      this.formasPagamentoMesa = this.empresa.formasDePagamento.filter((item: any) =>
        !item.online && item.fiado !== true && item.exibirCardapioMesa !== false);
      this.carregandoFormasPagamentos = false;
    }

    //tirando cashback e fidelidade
    this.formasPagamentoMesa = this.formasPagamentoMesa.filter(
      (item: any) => !item.formaDePagamentoPdv || item.formaDePagamentoPdv.tipo !== 'FIDELIDADE' )
  }

  private empresaTemEcletica() {
    return String(this.empresa?.integracaoDelivery?.sistema || '').toLowerCase() === 'ecletica';
  }

  fecharEImprimir() {
    this.onSubmitFecharComanda(true);
  }

  novoPedidoComanda() {
    this.pedidoLocalService.remova(this.comanda.cliente.telefone);
    this.router.navigate([obtenhaRotaNovoPedidoLocal()],
      {queryParams:  {
          idm: this.comanda.mesa.id,
          idc: this.comanda.id,
          modoEdicao: true,
          urlRetorno: '/admin/pedidos-mesas'}
      }).then( () => {});
  }


  trocaMesa() {
    this.router.navigate(['/admin/pedidos/trocar-mesa'],
      {queryParams: {idc: this.comanda.id, idm: this.comanda.mesa.id}}).then( () => {});
  }

  abraModalVincularGarcom() {
    if(!this.comanda || (!this.comanda.aberta && !this.comanda.emFechamento)) return;

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalVincularGarcomComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    windowRef.content.instance.empresa = this.empresa;
    windowRef.content.instance.mesa = this.comanda.mesa;
    windowRef.content.instance.comanda = Object.assign({}, this.comanda);

    if(this.comanda.garcom && this.comanda.garcom.id)
      windowRef.content.instance.setGarcom(this.comanda.garcom);

    windowRef.result.subscribe(async (comandaAtualizada: any) => {
      if(!comandaAtualizada || !comandaAtualizada.id) return;

      await this.setComanda(comandaAtualizada);
    });
  }

  recarregueComanda(comanda){

    this.pedidosService.obtenhaComandaComoPedido(comanda.id).then( (resposta: any) => {
      this.setComanda(resposta)
    }).catch( (erro) => {

    });

  }


  totalDaComanda(){
    if( this.ehParaCobrarTaxa())
        return  this.comanda.totalComTaxa;

    return this.totalSemTaxa();
  }

  ehParaCobrarTaxa(){
    if(this.empresa.cobrarTaxaServico) return this.comanda.cobrarTaxaServico;

    return false;
  }

  exibeTaxaServico(){
    return this.ehParaCobrarTaxa();
  }

  totalSemTaxa(){
    return this.comanda.valor - this.desconto;
  }

  exibeResumoPagamentoFechamento(): boolean {
    return !!(this.comanda && (this.comanda.aberta || this.comanda.emFechamento) &&
      this.comanda.valor && !this.exibirPrefechamento && !this.pixOnlineTunaPendente());
  }

  pagamentosResumoFechamento(): any[] {
    const pagamentos = (this.gridPagamentos?.pagamentos || [])
      .filter((pagamento: any) => pagamento && !pagamento.removido && pagamento.formaDePagamento);

    if(!pagamentos.length && this.pixOnlineTunaSelecionadoParaGerar()) {
      return [{
        formaDePagamento: this.formaPixOnlineTuna,
        valor: this.totalDaComanda()
      }];
    }

    return pagamentos;
  }

  tituloResumoPagamentoFechamento(): string {
    const pagamentos = this.pagamentosResumoFechamento();

    if(!pagamentos.length) return 'Pendente';
    if(pagamentos.length > 1) return 'Dividido';

    return this.descricaoResumoPagamento(pagamentos[0]);
  }

  descricaoResumoPagamento(pagamento: any): string {
    return pagamento?.formaDePagamento?.descricao || pagamento?.formaDePagamento?.nome || 'Pagamento';
  }

  pagamentoTemTroco(pagamento: any): boolean {
    return this.valorTrocoPagamento(pagamento) > 0;
  }

  valorRecebidoTrocoPagamento(pagamento: any): number {
    return Number(pagamento?.trocoPara || 0);
  }

  valorTrocoPagamento(pagamento: any): number {
    const valorTroco = Number(pagamento?.valorTroco || 0);

    if(valorTroco > 0)
      return Number(valorTroco.toFixed(2));

    const troco = Number(pagamento?.trocoPara || 0) - Number(pagamento?.valor || 0);

    return troco > 0 ? Number(troco.toFixed(2)) : 0;
  }

  valorRecebidoResumoPagamento(pagamento: any): number {
    return Number(pagamento?.trocoPara || pagamento?.valor || 0);
  }

  trocoResumoPagamento(pagamento: any): number {
    const troco = this.valorRecebidoResumoPagamento(pagamento) - Number(pagamento?.valor || 0);

    return troco > 0 ? Number(troco.toFixed(2)) : 0;
  }

  private valorPagamentoSemTaxaResumo(pagamento: any): number {
    const valor = Number(pagamento?.valor || 0) - Number(pagamento?.taxa || 0);

    return Number(valor.toFixed(2));
  }

  descontoResumoPagamento(pagamento: any): number {
    const desconto = Number(pagamento?.desconto || 0);

    return Number(desconto.toFixed(2));
  }

  private valorCoberturaResumoPagamento(pagamento: any): number {
    const valor = this.valorPagamentoSemTaxaResumo(pagamento) + this.descontoResumoPagamento(pagamento);

    return Number(valor.toFixed(2));
  }

  totalDescontoResumoPagamento(): number {
    const total = this.pagamentosResumoFechamento()
      .reduce((soma: number, pagamento: any) => soma + this.descontoResumoPagamento(pagamento), 0);

    return Number(total.toFixed(2));
  }

  totalTaxaResumoPagamento(): number {
    const total = this.pagamentosResumoFechamento()
      .reduce((soma: number, pagamento: any) => soma + Number(pagamento?.taxa || 0), 0);

    return Number(total.toFixed(2));
  }

  diferencaResumoPagamento(): number {
    const pagamentos = this.pagamentosResumoFechamento();

    if(pagamentos.length === 1) return 0;

    const totalPago = pagamentos
      .reduce((total: number, pagamento: any) => total + this.valorCoberturaResumoPagamento(pagamento), 0);

    return Number((this.totalDaComanda() - totalPago).toFixed(2));
  }

  iconeResumoPagamento(pagamento: any): string {
    const texto = String(`${pagamento?.formaDePagamento?.nome || ''} ${pagamento?.formaDePagamento?.descricao || ''}`)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

    if(texto.includes('pix')) return 'fas fa-qrcode';
    if(texto.includes('dinheiro')) return 'fas fa-money-bill-wave';
    if(texto.includes('credito') || texto.includes('credit')) return 'fas fa-credit-card';
    if(texto.includes('debito') || texto.includes('debit')) return 'fas fa-id-card';

    return 'fas fa-wallet';
  }

  pixOnlineTunaSelecionadoParaGerar(): boolean {
    return !!(!this.pixOnlineTunaPendente() && this.gridPagamentos &&
      this.gridPagamentos.pixOnlineTunaSelecionado &&
      this.gridPagamentos.pixOnlineTunaSelecionado());
  }

  bloqueiaFecharPorPixOnline(): boolean {
    return this.pixOnlineTunaPendente() || this.pixOnlineTunaSelecionadoParaGerar();
  }

  alterouCobarTaxa(){
    if(this.pixOnlineTunaPendente()) return;

    this.recalculeTotalComanda();

    let dados: any = {id: this.comanda.id, cobrarTaxaServico: this.comanda.cobrarTaxaServico}

    this.pedidosService.atualizeCobrarTaxa(dados).then( (resposta) => {
    }).catch((erro) => {
      this.comanda.cobrarTaxaServico = !this.comanda.cobrarTaxaServico;
      alert(erro)
    })
  }

  recalculeTotalComanda() {
    if(this.pixOnlineTunaPendente()) return;

    if (this.tipoDesconto === 'porcentagem') {
       this.desconto = (this.comanda.valor * this.valorDescontoInput) / 100;
       // Arredondar para 2 casas decimais
       this.desconto = Math.round(this.desconto * 100) / 100;
    } else {
       this.desconto = this.valorDescontoInput;
    }

    if (this.ehParaCobrarTaxa()){
      let taxa = this.empresa.valorTaxaServico / 100;
      let totalSemTaxa = this.totalSemTaxa();

      this.comanda.taxaServico = totalSemTaxa * taxa;
      this.comanda.totalComTaxa = totalSemTaxa + this.comanda.taxaServico;

      this.comanda.taxaServico = Number(this.comanda.taxaServico.toFixed(2))
      this.comanda.totalComTaxa = Number(this.comanda.totalComTaxa.toFixed(2))
    } else {
      this.comanda.taxaServico  = 0;
      this.comanda.totalComTaxa  = this.totalSemTaxa();
    }

    this.sincronizeTotalGridPagamentos();

    this.calculePontosAhReceber();
  }

  private sincronizeTotalGridPagamentos() {
    setTimeout(() => {
      if(this.pixOnlineTunaPendente()) return;

      if(this.gridPagamentos)
        this.gridPagamentos.novoValorPagar(this.totalDaComanda())
    }, 0);
  }

  calculePontosAhReceber(){
    this.comanda.pontosReceber = null;

    if(this.empresa.integracaoPedidoFidelidade){
      let integracao = this.empresa.integracaoPedidoFidelidade;

      if(!integracao.pontuarMesas) return;

      let pontuacaoRegistrada: PontuacaoRegistrada = new PontuacaoRegistrada();

      pontuacaoRegistrada.valor =  this.totalSemTaxa();
      pontuacaoRegistrada.cartao = integracao.cartao ? integracao.cartao : {};
      pontuacaoRegistrada.cartao.plano = integracao.plano;
      pontuacaoRegistrada.atividades = [integracao.atividade];

      let tipoDePontuacao = integracao.plano.tipoDePontuacao;

      let itens = [];

      this.comanda.pedidos.forEach((pedido: any) => {
        if(!pedido.cancelado){
          itens.push(...pedido.itens)
        }
      })

      let pontos =
        IUITipoDePontuacaoFactory.obtenhaTipodePontuacao(this.empresa, tipoDePontuacao).
        calculePontuacao(pontuacaoRegistrada, itens);

      this.comanda.pontosReceber =
        FormatadorPontos.obtenhaPtsFormatado(integracao.plano.tipoDePontuacao, integracao.plano.tipoDeAcumulo, pontos)
    }

  }

 async imprimirComanda($event: any, nativa = false){
    if(this.imprimindo) return;

    this.imprimindo = true;

    try{
      if(this.desconto !== this.comanda.desconto)
        await this.comandaService.atualizeDesconto(this.comanda, this.desconto);

      if(nativa){
        this.imprimaNativamenteComanda(this.comanda, $event);
      } else {
        if(this.configImpressao && this.configImpressao.layoutPedido  === 'Ambos'){
          this.imprimaUmDosLeiautesComanda(this.comanda, $event)
        } else {
          this.imprimaLayoutUnicoComanda(this.comanda);
        }
      }
    } finally {
      this.imprimindo = false;
    }
  }



  alterouFecharParceiro() {
    this.fecharSemPrechamento = this.fecharSomenteMeucardapio ? true : false;

    if(this.fecharSomenteMeucardapio){
      this.exibirPrefechamento = false;
      this.setFormasPagamentoMesa();
    } else {
      this.exibirPrefechamento = this.comanda.preFechamentoDisponivel ? true : false;
      this.setFormasPagamentoMesa();
    }
  }

  obtenhaFormatoPercentual(){
    return String(`0"%  (R$ ${this.desconto.toFixed(2).replace('.', ',')})"`);
  }

  obtenhaNumeroComandaPixOnline() {
    if(!this.comanda) return '';

    return this.comanda.codigoPdv || this.comanda.id;
  }

  obtenhaDataAberturaComandaPixOnline() {
    if(!this.comanda) return '';

    return this.comanda.horarioAberturaDescricao || this.comanda.horarioAbertura || '';
  }

  private preenchaDadosClientePixOnline() {
    const cliente = this.comanda ? (this.comanda.cliente || {}) : {};

    if(this.ehConsumidorNaoIdentificado(cliente)){
      this.dadosClientePixOnline = {};
      return;
    }

    this.dadosClientePixOnline = {
      nome: cliente.nome || this.dadosClientePixOnline.nome,
      email: cliente.email || this.dadosClientePixOnline.email,
      telefone: cliente.telefone || this.dadosClientePixOnline.telefone
    };
  }

  private ehConsumidorNaoIdentificado(cliente: any) {
    const telefone = cliente && cliente.telefone ? String(cliente.telefone).replace(/\D/g, '') : '';

    return telefone === '00000000000';
  }

  private obtenhaDadosClientePixOnline() {
    return {
      nome: String(this.dadosClientePixOnline?.nome || '').trim(),
      email: String(this.dadosClientePixOnline?.email || '').trim(),
      telefone: this.obtenhaTelefonePixOnlineLimpo()
    };
  }

  private obtenhaTelefonePixOnlineLimpo() {
    return String(this.dadosClientePixOnline?.telefone || '').replace(/\D/g, '');
  }

  temPixOnlineTuna() {
    return this.obtenhaFormaPixOnlineTuna() != null;
  }

  obtenhaFormaPixOnlineTuna() {
    if(!this.empresa || !this.empresa.meucardapioPay || !this.empresa.meucardapioPay.pixLiberado)
      return null;

    const formas = [
      ...(this.empresa.formasDePagamento || []),
      ...(this.formasPagamentoMesa || [])
    ];

    return formas.find((forma: any) => {
      const meio = forma && forma.configMeioDePagamento && forma.configMeioDePagamento.meioDePagamento ?
        String(forma.configMeioDePagamento.meioDePagamento).toLowerCase() : '';

      return forma && forma.pix && (meio === 'tunapay' || meio === 'cellcoinpay') && forma.exibirCardapioMesa !== false;
    });
  }

  abraModalPixOnlineTuna(pagamento: any = null) {
    if(pagamento)
      this.pagamentoPixOnline = this.montePagamentoPixOnlineParaExibir(pagamento);

    this.exibirPixOnlineTuna = true;
    this.confirmandoCancelamentoPixOnlineTuna = false;
    delete this.erroPixOnlineTuna;
    this.tentouGerarPixOnlineTuna = false;
    this.preenchaDadosClientePixOnline();
    this.inicieContadorPixOnline();
    this.foqueNomePixOnline();
  }

  fecheModalPixOnlineTuna() {
    this.exibirPixOnlineTuna = false;
    this.confirmandoCancelamentoPixOnlineTuna = false;
    this.pareContadorPixOnline();
  }

  gerePixOnlineTuna() {
    if(this.gerandoPixOnlineTuna) return;

    this.tentouGerarPixOnlineTuna = true;

    if(!this.nomePixOnlineValido()){
      this.erroPixOnlineTuna = 'Informe o nome do cliente para gerar o QR Code Pix';
      this.foqueNomePixOnline();
      return;
    }

    if(!this.emailPixOnlineValido()) {
      this.erroPixOnlineTuna = 'Informe um e-mail válido para gerar o QR Code Pix';
      return;
    }

    if(!this.telefonePixOnlineValido()) {
      this.erroPixOnlineTuna = 'Informe um telefone válido com DDD para gerar o QR Code Pix';
      return;
    }

    const dados = {
      cliente: this.obtenhaDadosClientePixOnline(),
      desconto: this.desconto,
      cobrarTaxaServico: this.ehParaCobrarTaxa()
    };

    this.gerandoPixOnlineTuna = true;
    this.mensagemPixCopiado = '';
    delete this.erroPixOnlineTuna;
    delete this.erro;

    this.comandaService.gerePixOnlineTuna(this.comanda, dados).then(async (resposta: any) => {
      this.gerandoPixOnlineTuna = false;
      if(resposta && resposta.comanda)
        await this.setComanda(resposta.comanda);

      this.pagamentoPixOnline = resposta.pagamento || this.pagamentoPixOnline;
      this.exibirPixOnlineTuna = true;
      this.tentouGerarPixOnlineTuna = false;
      this.inicieContadorPixOnline();
      this.atualizePollingPixOnline();
      delete this.erroPixOnlineTuna;
      if(this.gridPagamentos) this.gridPagamentos.limpePagamentos();
    }).catch((erro) => {
      this.gerandoPixOnlineTuna = false;
      this.erroPixOnlineTuna = erro;
    });
  }

  obtenhaUrlQrCodePixOnline() {
    if(!this.pagamentoPixOnline || !this.pagamentoPixOnline.codigoQrCode) return '';

    return '/api/qrcode?c=' + encodeURIComponent(this.pagamentoPixOnline.codigoQrCode);
  }

  copiePixOnline() {
    if(!this.pagamentoPixOnline || !this.pagamentoPixOnline.codigoQrCode) return;

    navigator.clipboard.writeText(this.pagamentoPixOnline.codigoQrCode).then(() => {
      this.mensagemPixCopiado = 'Código Pix copiado.';
    }).catch(() => {
      this.mensagemPixCopiado = 'Não foi possível copiar automaticamente.';
    });
  }

  nomePixOnlineValido() {
    return String(this.dadosClientePixOnline?.nome || '').trim().length > 0;
  }

  nomePixOnlineInvalido() {
    return !this.nomePixOnlineValido();
  }

  emailPixOnlineValido() {
    const email = String(this.dadosClientePixOnline?.email || '').trim();
    if(!email) return true;

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  emailPixOnlineInvalido() {
    return !this.emailPixOnlineValido();
  }

  telefonePixOnlineValido() {
    const telefone = this.obtenhaTelefonePixOnlineLimpo();
    if(!telefone) return true;

    const regexFixo = /^[1-9]{2}[2-5][0-9]{7}$/;
    const regexCelular = /^[1-9]{2}9[0-9]{8}$/;

    return regexFixo.test(telefone) || regexCelular.test(telefone);
  }

  telefonePixOnlineInvalido() {
    return !this.telefonePixOnlineValido();
  }

  private foqueNomePixOnline() {
    if(this.pagamentoPixOnline) return;

    setTimeout(() => {
      if(this.pixClienteNomeInput && this.pixClienteNomeInput.nativeElement)
        this.pixClienteNomeInput.nativeElement.focus();
    }, 0);
  }

  soliciteCancelamentoPixOnlineTuna() {
    if(!this.pagamentoPixOnline || this.cancelandoPixOnlineTuna) return;

    this.confirmandoCancelamentoPixOnlineTuna = true;
    delete this.erroPixOnlineTuna;
  }

  volteCancelamentoPixOnlineTuna() {
    if(this.cancelandoPixOnlineTuna) return;

    this.confirmandoCancelamentoPixOnlineTuna = false;
    delete this.erroPixOnlineTuna;
  }

  cancelePixOnlineTuna() {
    if(!this.pagamentoPixOnline || this.cancelandoPixOnlineTuna) return;

    this.cancelandoPixOnlineTuna = true;
    delete this.erroPixOnlineTuna;
    this.comandaService.cancelePixOnlineTuna(this.comanda, this.pagamentoPixOnline).then((resposta: any) => {
      this.cancelandoPixOnlineTuna = false;
      this.pagamentoPixOnline = null;
      this.confirmandoCancelamentoPixOnlineTuna = false;
      this.mensagemPixCopiado = '';
      delete this.erroPixOnlineTuna;
      this.exibirPixOnlineTuna = false;
      this.pareContadorPixOnline();
      this.parePollingPixOnline();

      if(resposta && resposta.comanda)
        this.setComanda(resposta.comanda);
    }).catch((erro) => {
      this.cancelandoPixOnlineTuna = false;
      this.erroPixOnlineTuna = erro;
    });
  }

  pixOnlineTunaPendente() {
    return this.pagamentoPixOnline != null || this.obtenhaPixOnlineTunaPendente() != null;
  }

  ehPagamentoPixOnlineTunaPendente(pagamento: any) {
    return this.pagamentoPixOnlineTuna(pagamento) && this.pagamentoPendente(pagamento);
  }

  obtenhaDataExpiracaoPixOnline(pagamento: any) {
    const pagamentoPix = this.montePagamentoPixOnlineParaExibir(pagamento);

    return pagamentoPix ? pagamentoPix.dataExpiracao : null;
  }

  private obtenhaPixOnlineTunaPendente() {
    const pagamentos = this.comanda && this.comanda.pagamentos ? this.comanda.pagamentos : [];

    return pagamentos.find((pagamento: any) => this.ehPagamentoPixOnlineTunaPendente(pagamento));
  }

  private pagamentoPixOnlineTuna(pagamento: any) {
    const forma = pagamento && pagamento.formaDePagamento ? pagamento.formaDePagamento : {};
    const meioDePagamento = forma.configMeioDePagamento && forma.configMeioDePagamento.meioDePagamento ?
      String(forma.configMeioDePagamento.meioDePagamento).toLowerCase() : '';

    return !!(forma.pix && (pagamento.online || forma.online || meioDePagamento === 'tunapay' || meioDePagamento === 'cellcoinpay' ||
      (this.formaPixOnlineTuna && forma.id === this.formaPixOnlineTuna.id)));
  }

  private pagamentoPendente(pagamento: any) {
    if(!pagamento) return false;

    const statusNumero = pagamento.statusNumero != null ? Number(pagamento.statusNumero) : Number(pagamento.status);
    const status = pagamento.status ? String(pagamento.status).toLowerCase() : '';

    return statusNumero === 1 || status.indexOf('aguardando') >= 0 || status.indexOf('pendente') >= 0;
  }

  private montePagamentoPixOnlineParaExibir(pagamento: any) {
    if(!pagamento) return null;

    if(this.pagamentoPixOnline && this.pagamentoPixOnline.id === pagamento.id)
      return Object.assign({}, pagamento, this.pagamentoPixOnline);

    return pagamento;
  }

  private inicieContadorPixOnline() {
    this.pareContadorPixOnline();
    this.atualizeContadorPixOnline();

    if(this.pagamentoPixOnline && this.pagamentoPixOnline.dataExpiracao && !this.pixOnlineTunaExpirado)
      this.pixOnlineTunaTimer = setInterval(() => this.atualizeContadorPixOnline(), 1000);
  }

  private pareContadorPixOnline() {
    if(this.pixOnlineTunaTimer)
      clearInterval(this.pixOnlineTunaTimer);

    this.pixOnlineTunaTimer = null;
  }

  private atualizeContadorPixOnline() {
    const dataExpiracao = this.obtenhaDataExpiracaoPagamentoPixOnline();

    if(!dataExpiracao) {
      this.pixOnlineTunaTempoRestante = '';
      this.pixOnlineTunaExpirado = false;
      return;
    }

    const totalSegundos = Math.max(0, Math.floor((dataExpiracao.getTime() - new Date().getTime()) / 1000));
    const minutos = Math.floor(totalSegundos / 60);
    const segundos = totalSegundos % 60;

    this.pixOnlineTunaTempoRestante = this.formateTempoPixOnline(minutos) + ':' + this.formateTempoPixOnline(segundos);
    this.pixOnlineTunaExpirado = totalSegundos <= 0;

    if(this.pixOnlineTunaExpirado)
      this.pareContadorPixOnline();
  }

  private obtenhaDataExpiracaoPagamentoPixOnline() {
    if(!this.pagamentoPixOnline || !this.pagamentoPixOnline.dataExpiracao) return null;

    const dataExpiracao = new Date(this.pagamentoPixOnline.dataExpiracao);

    return isNaN(dataExpiracao.getTime()) ? null : dataExpiracao;
  }

  private formateTempoPixOnline(valor: number) {
    return valor < 10 ? '0' + valor : String(valor);
  }

  private atualizePollingPixOnline() {
    if(this.pixOnlineTunaPendente()) {
      this.iniciePollingPixOnline();
    } else {
      this.parePollingPixOnline();
    }
  }

  private iniciePollingPixOnline() {
    if(this.pixOnlineTunaPolling) return;

    this.pixOnlineTunaPolling = setInterval(() => this.sincronizePixOnlineTuna(), 10 * 1000);
  }

  private parePollingPixOnline() {
    if(this.pixOnlineTunaPolling)
      clearInterval(this.pixOnlineTunaPolling);

    this.pixOnlineTunaPolling = null;
    this.sincronizandoPixOnlineTuna = false;
  }

  sincronizePixOnlineTuna(pagamentoManual: any = null, exibirErro: boolean = false,
                          avisarSePendente: boolean = false, forcar: boolean = false) {
    if(this.sincronizandoPixOnlineTuna || !this.comanda) return;

    const pagamento = pagamentoManual || this.pagamentoPixOnline || this.obtenhaPixOnlineTunaPendente();
    if(!pagamento) {
      this.parePollingPixOnline();
      return;
    }

    this.sincronizandoPixOnlineTuna = true;
    if(exibirErro) this.limpeErroSincronizacaoPixOnline();
    this.comandaService.sincronizePixOnlineTuna(this.comanda, pagamento, forcar).then(async (resposta: any) => {
      this.sincronizandoPixOnlineTuna = false;
      const pagamentoAindaPendente = resposta && resposta.comanda ?
        this.obtenhaPagamentoPixOnlinePendenteNaComanda(resposta.comanda, pagamento.id) : null;

      if(resposta && resposta.comanda)
        await this.setComanda(resposta.comanda);
      else
        this.atualizePollingPixOnline();

      if(exibirErro && avisarSePendente && pagamentoAindaPendente)
        this.exibaErroSincronizacaoPixOnline('Pagamento ainda pendente');
    }).catch((erro) => {
      this.sincronizandoPixOnlineTuna = false;
      if(exibirErro)
        this.exibaErroSincronizacaoPixOnline(erro);
    });
  }

  jaPagouPixOnlineTuna(pagamento: any = null) {
    this.sincronizePixOnlineTuna(pagamento, true, true, true);
  }

  private limpeErroSincronizacaoPixOnline() {
    delete this.erroPixOnlineTuna;
    delete this.erro;
    this.erroAnimando = false;
  }

  private exibaErroSincronizacaoPixOnline(erro: string) {
    this.erroPixOnlineTuna = erro;
    this.setErro(erro);
  }

  private obtenhaPagamentoPixOnlinePendenteNaComanda(comanda: any, idPagamento: any) {
    const pagamentos = comanda && comanda.pagamentos ? comanda.pagamentos : [];

    return pagamentos.find((pagamento: any) =>
      Number(pagamento.id) === Number(idPagamento) && this.ehPagamentoPixOnlineTunaPendente(pagamento));
  }

}
